import React, { PureComponent } from 'react'
import styled from 'styled-components'
import UTM from '../../../components/utils/UTM'
import Link from '../../../components/utils/Link'
import { SIZES } from '../../../constants'

const Wrapper = styled.div`
  align-items: flex-end;
  display: flex;
  display: -ms-flexbox;
  -ms-flex-align: end;
  margin-bottom: 20px;

  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    border-bottom: 1px solid #d1d1d1;
  }
`

const WeatherContainer = styled.div`
  flex: 1 1 380px;
  max-width: 380px;
`

const WeatherLink = styled(Link)`
  color: ${props => props.theme.weather.button.color};
  font-size: 11px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  text-transform: uppercase;

  height: 66px;
  width: 86px;
  margin-bottom: 20px;
  margin-left: auto;
  border: 1px solid ${props => props.theme.weather.button.border};
  border-radius: 4px;
  background-color: ${props => props.theme.weather.button.background};

  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  &:hover {
    text-decoration: none;
    color: ${props => props.theme.weather.button.color};
    border: 1px solid ${props => props.theme.weather.button.hover.border};
    background-color: ${props => props.theme.weather.button.hover.background};
  }

  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    display: none;
  }
`

export default class ForecastWeather extends PureComponent {
  render () {
    const {
      widget: {
        meta: {
          container: {
            id
          },
          more: {
            location,
            text
          }
        },
        utmMedium,
        utmSource
      }
    } = this.props
    const link = new UTM(location).getUTMLink({utmMedium, utmSource})

    return (
      <Wrapper>
        <WeatherContainer id={`widget_tiny_forecast${id}_container`}/>
        <WeatherLink href={link}>
          { text }
        </WeatherLink>
      </Wrapper>
    )
  }
}
